import getAPIPath from '../modules/api-location';
import { sanitizeEmailAddress } from "../../app/utils/sanitizeUtils";

window.getLoggedInUserService = function(successFn, errorFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/user`,
    type: `get`,
    error: errorFn,
    success: successFn,
    statusCode: {
      401() {},
    },
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};

window.userExistsService = function(emailAddress, successFn, errorFn) {
  console.log(`Before: ${emailAddress}`);
  emailAddress = sanitizeEmailAddress(emailAddress);
  console.log(`After: ${emailAddress}`);
  return $.ajax({
    url: `${getAPIPath}queryapi/user/does-exist?email_address=${emailAddress}`,
    type: `get`,
    error: errorFn,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};

window.userNeedsUpgradeService = function(emailAddress, newPlan, teamId, successFn) {
  emailAddress = sanitizeEmailAddress(emailAddress);
  return $.ajax({
    url: `${getAPIPath}queryapi/user-needs-upgrade?new_plan=${newPlan}&email_address=${emailAddress}&team_id=${teamId}`,
    type: `get`,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/user.service.js